import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import Navigation from '../components/navigation';
import Footer from '../components/footer';
import './single-post-view.css';
import { BlocksRenderer } from '@strapi/blocks-react-renderer';

const SinglePostView = () => {
  const { slug } = useParams();
  const [post, setPost] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchPost = async () => {
      try {
        const res = await fetch(`${process.env.REACT_APP_API_URL}/api/articles?filters[slug][$eq]=${slug}&populate=*`);
        // const res = await fetch(`http://127.0.0.1:1337/api/articles?filters[slug][$eq]=${slug}&populate=*`);
        const data = await res.json();

        if (data.data && data.data.length > 0) {
          const article = data.data[0];
          setPost({
            title: article.title,
            body: article.haupt_text || [],
            author: article.author?.name || 'Unbekannter Autor',
            date: new Date(article.publishedAt).toLocaleDateString(),
            cover: article.cover?.[0]?.url
              ? `${process.env.REACT_APP_API_URL}${article.cover[0].url}`
              : null,
            // cover: article.cover?.[0]?.url
            //   ? `http://127.0.0.1:1337${article.cover[0].url}`
            //   : null,
          });
        } else {
          setError('Artikel nicht gefunden.');
        }
      } catch (err) {
        console.error('Error fetching post:', err);
        setError('Fehler beim Laden des Artikels.');
      } finally {
        setLoading(false);
      }
    };

    fetchPost();
  }, [slug]);

  if (loading) {
    return <div>Lädt...</div>;
  }

  if (error) {
    return <div>{error}</div>;
  }

  if (!post) {
    return <div>Kein Artikel gefunden.</div>;
  }

  return (
    <div className="single-post-view-container">
      <Navigation />
      <div className="single-post-view-content">
        {post.cover && <img src={post.cover} alt={post.title} className="single-post-view-cover" />}
        <h1 className="single-post-view-title">{post.title}</h1>
        <div className="single-post-view-meta">
          <span className="single-post-view-author">{post.author}</span> |{' '}
          <span className="single-post-view-date">{post.date}</span>
        </div>
        <div className="single-post-view-body">
          <BlocksRenderer content={post.body} />
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default SinglePostView;
